import React from 'react';
import PropTypes from 'prop-types';
import CascadeDeletionModal from './CascadeDeletionModal';
import { section } from './describeRow';
import ContractService from '../../services/contract.service';
import CreditService from '../../services/credit.service';
import AssetService from '../../services/asset.service';
import AssetSaleService from '../../services/assetSale.service';
import BankAccountService from '../../services/bankAccount.service';

// Per-entity configuration of the generic cascade modal. The server decides
// what is deleted; these only pick which preview sections are itemised.
const CONTRACT_SECTIONS = [
	section('debts', 'entity.debt.plural'),
	section('credits', 'entity.credit.plural'),
	section('commissions', 'entity.commission.plural'),
	section('documents', 'entity.document.plural'),
];
const CREDIT_SECTIONS = [section('documents', 'entity.document.plural')];
const ASSET_SECTIONS = [
	section('contracts', 'entity.contract.plural'),
	section('assetSales', 'entity.assetSale.plural'),
	section('debts', 'entity.debt.plural'),
	section('credits', 'entity.credit.plural'),
	section('commissions', 'entity.commission.plural'),
	section('documents', 'entity.document.plural'),
];
const ASSET_SALE_SECTIONS = [
	section('debts', 'entity.debt.plural'),
	section('commissions', 'entity.commission.plural'),
	section('documents', 'entity.document.plural'),
];
// Bank accounts delete nothing but themselves: the rows listed are the
// records that will stop referencing it.
const BANK_ACCOUNT_SECTIONS = [
	section('accounts', 'entity.account.plural', 'unlinkedEntities'),
	section('contracts', 'entity.contract.plural', 'unlinkedEntities'),
	section('assetSales', 'entity.assetSale.plural', 'unlinkedEntities'),
];

const entityModal = (displayName, config) => {
	const Modal = ({ show, record, onClose, onDeleted }) => (
		<CascadeDeletionModal
			show={show}
			entityId={record?._id}
			onClose={onClose}
			onDeleted={onDeleted}
			{...config}
		/>
	);
	Modal.displayName = displayName;
	Modal.propTypes = {
		show: PropTypes.bool.isRequired,
		record: PropTypes.shape({ _id: PropTypes.string }),
		onClose: PropTypes.func.isRequired,
		onDeleted: PropTypes.func.isRequired,
	};
	return Modal;
};

export const ContractDeletionModal = entityModal('ContractDeletionModal', {
	service: ContractService,
	rootKey: 'contract',
	titleKey: 'title.deleteContract',
	deletedMsgKey: 'msg.contractDeleted',
	noticeKey: 'msg.contractDeleteVsClose',
	sections: CONTRACT_SECTIONS,
});
export const CreditDeletionModal = entityModal('CreditDeletionModal', {
	service: CreditService,
	rootKey: 'credit',
	titleKey: 'title.deleteCredit',
	deletedMsgKey: 'msg.creditDeleted',
	sections: CREDIT_SECTIONS,
});
export const AssetDeletionModal = entityModal('AssetDeletionModal', {
	service: AssetService,
	rootKey: 'asset',
	titleKey: 'title.deleteAsset',
	deletedMsgKey: 'msg.assetDeleted',
	sections: ASSET_SECTIONS,
});
export const AssetSaleDeletionModal = entityModal('AssetSaleDeletionModal', {
	service: AssetSaleService,
	rootKey: 'assetSale',
	titleKey: 'title.deleteAssetSale',
	deletedMsgKey: 'msg.assetSaleDeleted',
	sections: ASSET_SALE_SECTIONS,
});
export const BankAccountDeletionModal = entityModal('BankAccountDeletionModal', {
	service: BankAccountService,
	rootKey: 'bankAccount',
	titleKey: 'title.deleteBankAccount',
	deletedMsgKey: 'msg.bankAccountDeleted',
	introKey: 'msg.bankAccountDeleteIntro',
	sections: BANK_ACCOUNT_SECTIONS,
});

export default CascadeDeletionModal;
